import { render, staticRenderFns } from "./ChangeAccountModal.vue?vue&type=template&id=fda254b6&scoped=true&"
import script from "./ChangeAccountModal.vue?vue&type=script&lang=js&"
export * from "./ChangeAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAccountModal.vue?vue&type=style&index=0&id=fda254b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda254b6",
  null
  
)

export default component.exports